import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { Fetcher } from '../../../Helpers/fetcher';
import { Notify } from '../../../Helpers/notification';

const UpdateSubSuperAdminUser = ({ app, selectedUserId }) => {
	const apiPath = app.apiPath
	const userId = app.userId
	const history = useHistory();

	const [formData, setFormData] = useState({
		name: '',
		emailid: '',
		number: '',
		company: '',
		address: '',
		pincode: '',
		accountType: [],
		aclId: "",
		themeColor: '#2c5282',
		sidebarPosition: 'left',
		sendDate: new Date(),
		loading: false
	});
	const [aclList, setAclList] = useState([])
	const [loading, setLoading] = useState(false)

	const saveUiSettings = async ({ themeColor, sidebarPosition }) => {
		try {
			await Fetcher.post(`${apiPath}/api/obd/user/${selectedUserId}/ui/settings`, {
				method: "POST",
				headers: { "Content-type": "application/json" },
				body: JSON.stringify({ json: JSON.stringify({ themeColor, sidebarPosition }) })
			});
		} catch (error) {
			console.log("saveUiSettings error", error);
		}
	};

	const encodeAccountType = (types) => {
		const hasPromotional = types.includes("0");
		const hasTransactional = types.includes("1");
		if (hasPromotional && hasTransactional) return 3;
		if (hasTransactional) return 1;
		if (hasPromotional) return 0;
		return "";
	};

	const decodeAccountType = (value) => {
		const num = Number(value);
		if (num === 3) return ["0", "1"];
		if (num === 1) return ["1"];
		if (num === 0) return ["0"];
		return [];
	};

	const toggleAccountType = (value) => {
		setFormData(prev => {
			const current = Array.isArray(prev.accountType) ? prev.accountType : [];
			const updated = current.includes(value)
				? current.filter(v => v !== value)
				: [...current, value];
			return { ...prev, accountType: updated };
		});
	};

	const getAclList = async () => {
		try {
			const res = await Fetcher.get(`${apiPath}/api/obd/acl/setting/unallocated/list/${userId}?excludeUserId=${selectedUserId}`)
			const data = Array.isArray(res) ? res : []
			setAclList(data)
		} catch (error) {
			Notify.notify("Error while getting the module list")
			console.log("getAclList", error)
		}
	}

	const getUserDetails = async () => {
		setLoading(true)
		try {
			const res = await Fetcher.get(`${apiPath}/api/obd/user/profile/${selectedUserId}`)

			let themeColor = '#2c5282';
			let sidebarPosition = 'left';
			try {
				const uiRes = await Fetcher.get(`${apiPath}/api/obd/user/${selectedUserId}/ui/settings`);
				const parsed = uiRes?.json ? JSON.parse(uiRes.json) : {};
				if (parsed?.themeColor) themeColor = parsed.themeColor;
				if (parsed?.sidebarPosition) sidebarPosition = parsed.sidebarPosition;
			} catch (uiError) {
				console.log("getUserDetails ui/settings error", uiError)
			}

			setFormData({
				name: res?.name || '',
				emailid: res?.emailid || '',
				number: res?.number || '',
				address: res?.address || '',
				company: res?.company || '',
				pincode: res?.pincode || '',
				accountType: decodeAccountType(res?.accountType),
				aclId: res?.aclId ?? '',
				themeColor,
				sidebarPosition,
				sendDate: res?.expiryDate ? new Date(res.expiryDate) : new Date(),
				loading: false
			})
		} catch (error) {
			Notify.notify("Error while getting the user details")
			console.log("getUserDetails", error)
		} finally {
			setLoading(false)
		}
	}

	const filterTime = (date) => {
		return new Date().getTime() <= date.getTime();
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));
	};

	const handleDateChange = (date) => {
		setFormData(prev => ({
			...prev,
			sendDate: date
		}));
	};

	const addZero = (i) => (i < 10 ? "0" + i : i);

	const updateUser = (e) => {
		e.preventDefault();

		if (!formData.accountType.length) return Notify.notify("Select Account Type");
		if (!formData.aclId) return Notify.notify("Select ACL");
		if (!formData.sendDate) return Notify.notify("Select Expiry Date");

		const d = formData.sendDate;
		const formattedDate = `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} 23:59:59`;

		const data = {
			userId: selectedUserId,
			name: formData.name,
			emailid: formData.emailid,
			number: formData.number,
			address: formData.address,
			company: formData.company,
			pincode: formData.pincode,
			parent: userId,
			accountType: encodeAccountType(formData.accountType),
			userType: "sub_sadmin",
			expiryDate: formattedDate,
			aclId: Number(formData.aclId)
		};

		setFormData(prev => ({ ...prev, loading: true }));

		Fetcher.post(`${apiPath}/api/obd/user/update`,
			{
				headers: {
					"Content-type": "application/json",
				},
				method: 'POST',
				body: JSON.stringify(data)
			}
		)
			.then(res => {
				if (res?.message?.toLowerCase().includes("success")) {
					saveUiSettings({
						themeColor: formData.themeColor,
						sidebarPosition: formData.sidebarPosition
					});
					Notify.notify("User Updated Successfully");
					history.push("/sub-super-admin/user-list");
					setFormData({
						name: '',
						emailid: '',
						number: '',
						company: '',
						address: '',
						pincode: '',
						accountType: [],
						aclId: "",
						themeColor: '#2c5282',
						sidebarPosition: 'left',
						sendDate: new Date(),
						loading: false
					});
				} else {
					Notify.notify(res?.message || "Something went wrong");
					setFormData(prev => ({ ...prev, loading: false }));
				}
			})
			.catch(err => {
				console.error(err);
				Notify.notify("Error Updating user");
				setFormData(prev => ({ ...prev, loading: false }));
			});
	};
	useEffect(() => {
		getUserDetails()
		getAclList()
	}, [])

	if (loading) {
		return (
			<div className="text-center py-5">
				<Spinner animation="border" />
				<div>Loading User Details...</div>
			</div>
		);
	}
	return (
		<Form onSubmit={updateUser}>
			<Row>
				<Col sm={12}>
					<Card>
						<Card.Header>Update Sub Super Admin User</Card.Header>

						<Card.Body>
							<Row>
								<Col sm={4}>
									<Form.Label>Name</Form.Label>
									<Form.Control
										name="name"
										placeholder="Enter name"
										value={formData.name}
										onChange={handleChange}
										required
									/>
								</Col>

								<Col sm={4}>
									<Form.Label>Email</Form.Label>
									<Form.Control
										type="email"
										name="emailid"
										placeholder="Enter email"
										value={formData.emailid}
										onChange={handleChange}
										required
									/>
								</Col>

								<Col sm={4}>
									<Form.Label>Mobile Number</Form.Label>
									<Form.Control
										name="number"
										placeholder="Enter mobile number"
										value={formData.number}
										onChange={handleChange}
										required
									/>
								</Col>
							</Row>

							<Row className="mt-3">
								<Col sm={4}>
									<Form.Label>Company Name</Form.Label>
									<Form.Control
										name="company"
										placeholder="Enter company"
										value={formData.company}
										onChange={handleChange}
										required
									/>
								</Col>

								<Col sm={4}>
									<Form.Label>Address</Form.Label>
									<Form.Control
										name="address"
										placeholder="Enter address"
										value={formData.address}
										onChange={handleChange}
										required
									/>
								</Col>

								<Col sm={4}>
									<Form.Label>Pincode</Form.Label>
									<Form.Control
										name="pincode"
										placeholder="Enter pincode"
										value={formData.pincode}
										onChange={handleChange}
										required
									/>
								</Col>
							</Row>

							<Row className="mt-3">
								<Col sm={4}>
									<Form.Label>Select Account Type</Form.Label>
									<div className="d-flex gap-4 mt-1">
										<Form.Check
											type="checkbox"
											id="update-accountType-promotional"
											label="Promotional"
											checked={formData.accountType.includes("0")}
											onChange={() => toggleAccountType("0")}
										/>
										<Form.Check
											type="checkbox"
											id="update-accountType-transactional"
											label="Transactional"
											checked={formData.accountType.includes("1")}
											onChange={() => toggleAccountType("1")}
										/>
									</div>
								</Col>
							</Row>

							<Row className="mt-3">
								<Col sm={4}>
									<Form.Label>User Expiry Date</Form.Label>
									<DatePicker
										className="form-control"
										selected={formData.sendDate}
										minDate={new Date()}
										dateFormat="yyyy-MM-dd"
										onChange={handleDateChange}
									/>
								</Col>

								<Col sm={4}>
									<Form.Label>ACL</Form.Label>
									<Form.Select
										name="aclId"
										value={formData.aclId}
										onChange={handleChange}
										required
										disabled={!aclList.length}
									>
										<option value="">
											{aclList.length ? "Select ACL" : "No ACL Available"}
										</option>
										{aclList.map(acl => (
											<option key={acl.id} value={acl.id}>
												{acl?.aclName}
											</option>
										))}
									</Form.Select>
								</Col>
								<Col sm={4}>
									<Form.Label>Brand Color</Form.Label>
									<div className="d-flex align-items-center gap-2">
										<Form.Control
											type="color"
											name="themeColor"
											title="Choose brand color"
											value={formData.themeColor}
											onChange={handleChange}
											style={{ width: 48, height: 38, padding: 4 }}
										/>
										<span className="text-muted" style={{ fontSize: "0.8rem" }}>
											Shown on the sidebar and buttons when this user logs in
										</span>
									</div>
								</Col>
							</Row>

							<Row className="mt-3">
								<Col sm={4}>
									<Form.Label>Sidebar Position</Form.Label>
									<div className="d-flex gap-4 mt-1">
										<Form.Check
											type="radio"
											id="update-sidebarPosition-left"
											name="sidebarPosition"
											label="Left"
											value="left"
											checked={formData.sidebarPosition === 'left'}
											onChange={handleChange}
										/>
										<Form.Check
											type="radio"
											id="update-sidebarPosition-right"
											name="sidebarPosition"
											label="Right"
											value="right"
											checked={formData.sidebarPosition === 'right'}
											onChange={handleChange}
										/>
										<Form.Check
											type="radio"
											id="update-sidebarPosition-top"
											name="sidebarPosition"
											label="Top"
											value="top"
											checked={formData.sidebarPosition === 'top'}
											onChange={handleChange}
										/>
									</div>
								</Col>
							</Row>

							<Button
								className="mt-3"
								variant="primary"
								type="submit"
								disabled={formData.loading}
							>
								{formData.loading ? "Updating..." : "Update User"}
							</Button>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Form>
	)
}

export default UpdateSubSuperAdminUser